<template>
  <div :style="hostWrapperStyle">
    <DynamicComponentProduction
      v-if="embeddedDcId"
      :dynamic-component-id="embeddedDcId"
      :is-production="renderingInProduction"
      :theme-mode="themeMode"
      @click="handleClick"
    />
  </div>
</template>

<script>
import { DynamicElementMixin } from "%/dynamic-component-editor/mixins/dynamic-element-mixin";
import LayoutWidthHeightOptions from "%/dynamic-component-editor/bundles/layout-width-height-options";
import DynamicComponentProduction
  from "%/dynamic-component-editor/components/DynamicComponentProductionComponent.vue";
import DcHostMixin from "%/dynamic-component-editor/mixins/dc-host-picker-mixin";
import ReferencedComponentId from "%/dynamic-component-editor/options/referenced-component-id";
import ContextBindings from "%/dynamic-component-editor/options/context-bindings";

// Embeds the destination's "Page Header" component. Each DC-host
// element is bound to one specific DC by name — `defaultComponentName`
// drives the lookup. Resolution flows through `DcHostMixin.embeddedDcId`,
// which reads from the App Engine `Destination.components` feed — the
// same store Feed reads for its row template.
export default {
  name: "PageHeader",
  components: { DynamicComponentProduction },
  mixins: [DynamicElementMixin, DcHostMixin],
  relatedComponents: ["Page Header"],
  elementPanelSettings: {
    tags: ["header", "masthead", "navigation", "top"],
    displayName: "Header",
    displayIcon: "header",
    elementGroup: "general",
    elementType: "element",
  },
  options: [ReferencedComponentId, ContextBindings],
  optionBundles: [
    new LayoutWidthHeightOptions({
      "default.layout-height": "hug",
      "default.layout-width": "fill",
    }),
  ],
  data() {
    return {
      defaultComponentName: "Page Header",
    };
  },
  methods: {
    handleClick(event) {
      if (this.editMode) {
        event.preventDefault();
      }
    },
  },
};
</script>
